<template>
  <div class="relative border-t border-border" data-test="sidebar-utente">
    <div class="flex items-center gap-2.5 p-3">
      <NuxtLink to="/profilo" class="focusable shrink-0 rounded-full" :aria-label="t('layout.utente.profilo')" @click="emit('naviga')">
        <UiAvatar :src="avatarSrc" :iniziali="iniziali" size="sm" />
      </NuxtLink>
      <div class="min-w-0 flex-1">
        <p class="truncate text-sm font-semibold" data-test="utente-nome">{{ username }}</p>
        <p class="text-xs text-text-muted">{{ amministratore ? t("layout.utente.amministratore") : t("layout.utente.utente") }}</p>
      </div>
      <!-- Esci direttamente, con la conferma: prima c'era un menu a tre puntini con una sola voce -->
      <UiButton v-tooltip.top="t('layout.utente.esci')" variant="ghost" size="sm" icon="fal fa-right-from-bracket" icon-hover="nudge" :aria-label="t('layout.utente.esci')" data-test="sidebar-esci" @click="confermaUscita = true" />
    </div>

    <UiDialog v-model:aperto="confermaUscita" :titolo="t('layout.utente.esci_titolo')" :descrizione="t('layout.utente.esci_messaggio')" size="sm">
      <template #footer>
        <UiButton variant="ghost" :label="t('layout.utente.annulla')" @click="confermaUscita = false" />
        <UiButton icon="fal fa-sign-out" :label="t('layout.utente.esci_conferma')" @click="esci" />
      </template>
    </UiDialog>
  </div>
</template>

<script setup lang="ts">
// Fondo del menu: scheda dell'utente (foto, nome, ruolo) con il pulsante «Esci», che chiede conferma; tema e lingua stanno nella barra globale
// (`LayoutBarraGlobale`). Il componente è solo vista: uscita e navigazione sono eventi che gestisce la sidebar.
import { useI18n } from "vue-i18n";

defineProps<{
  username: string;
  iniziali: string;
  avatarSrc: string | null;
  amministratore: boolean;
}>();

const emit = defineEmits<{ esci: []; naviga: [] }>();
const { t } = useI18n();
const confermaUscita = ref(false);

function esci(): void {
  confermaUscita.value = false;
  emit("esci");
}
</script>
